import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReceivedTicketPageComponent } from './received-ticket-page.component';
import { RouterModule } from '@angular/router';
import { TicketReceivedComponent } from '../../../mobile/modules/main/pages/season-ticket/components/ticket-received/ticket-received.component';

const route = [
  {
    path: '',
    component: ReceivedTicketPageComponent,
  },
];

@NgModule({
  imports: [
    //Components
    TicketReceivedComponent,
    //Modules
    CommonModule,
    RouterModule.forChild(route),
  ],
  declarations: [ReceivedTicketPageComponent],
  providers: [],
})
export class ReceivedTicketModule {}
